// 機關時間放開就存：別首歌也用這個 cue 時，放開才問一次。Esc / 點旁邊 = 取消（色塊回到拖之前，沒有寫入）。

import { useEffect, useRef } from 'react';
import './TimingScopeMenu.css';

export type TimingScope = 'one' | 'all';

interface Props {
  /** 用到這個 cue 的歌數 */
  songCount: number;
  onPick: (scope: TimingScope | null) => void;
}

export default function TimingScopeMenu({ songCount, onPick }: Props) {
  const first = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    first.current?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      e.preventDefault();
      e.stopPropagation();
      onPick(null);
    };
    // capture：比時間軸自己的 Esc 先接到
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [onPick]);
  return (
    <div className="timing-scope" onPointerDown={(e) => { if (e.target === e.currentTarget) onPick(null); }}>
      <div className="timing-scope__card" role="dialog" aria-label="別首歌也用這個 cue">
        <div className="timing-scope__title">別首歌也用這個 cue</div>
        <div className="timing-scope__actions">
          <button ref={first} type="button" className="btn btn--primary" onClick={() => onPick('one')}>只改這首</button>
          <button type="button" className="btn btn--ghost" onClick={() => onPick('all')}>全部一起改{songCount > 1 && <span className="timing-scope__count">{songCount} 首</span>}</button>
          <button type="button" className="btn btn--ghost" onClick={() => onPick(null)}>取消</button>
        </div>
      </div>
    </div>
  );
}
